
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSaveProposal as ObiSaveProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-save-proposal.js';
 
 
 

 
 export const ObiSaveProposal = createComponent({
   react: React,
   tagName: 'obi-save-proposal',
   elementClass: ObiSaveProposalElement,
   events: {
     
   }
  });
 
 